/* tslint:disable */
/* eslint-disable */
/**
 * Notification service API
 * Service for handling and managing notifications
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailForSendingDto
 */
export interface EmailForSendingDto {
    /**
     * email address
     * @type {string}
     * @memberof EmailForSendingDto
     */
    email: string;
    /**
     * email subject
     * @type {string}
     * @memberof EmailForSendingDto
     */
    subject: string;
    /**
     * email text
     * @type {string}
     * @memberof EmailForSendingDto
     */
    message: string;
}

/**
 * Check if a given object implements the EmailForSendingDto interface.
 */
export function instanceOfEmailForSendingDto(value: object): boolean {
    if (!('email' in value)) return false;
    if (!('subject' in value)) return false;
    if (!('message' in value)) return false;
    return true;
}

export function EmailForSendingDtoFromJSON(json: any): EmailForSendingDto {
    return EmailForSendingDtoFromJSONTyped(json, false);
}

export function EmailForSendingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailForSendingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'subject': json['subject'],
        'message': json['message'],
    };
}

export function EmailForSendingDtoToJSON(value?: EmailForSendingDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'subject': value['subject'],
        'message': value['message'],
    };
}

